import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';

/**
 * Generated class for the CustomInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-input',
  templateUrl: 'custom-input.html'
})
export class CustomInputComponent implements OnInit{
  @Input() id: string;
  @Input() label: string;
  @Input() type: string;
  @Input() placeHolder: string;
  @Input() textarea: 'true' | 'false'= 'false';
  @Input() inputModel: string;
  @Input() disabled: 'true' | 'false' = 'false';

  @Output() inputModelChange = new EventEmitter<string>();

  disable = false;

  constructor() {

  }

  ngOnInit() {
    this.disable = this.disabled != 'false';
  }

  onChange() {
    this.inputModelChange.emit(this.inputModel);
  }

}



// WEBPACK FOOTER //
// ./src/components/utils/custom-input/custom-input.ts